import { render, staticRenderFns } from "./EdicaoGenerica.vue?vue&type=template&id=474fa04e&scoped=true&"
import script from "./EdicaoGenerica.vue?vue&type=script&lang=ts&"
export * from "./EdicaoGenerica.vue?vue&type=script&lang=ts&"
import style0 from "./EdicaoGenerica.vue?vue&type=style&index=0&id=474fa04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474fa04e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer,VForm,VIcon})
